import React, { useState } from "react";
import ActionAreaCard from "./../DisplaySection/DisplayPdf";

import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid2 from "@mui/material/Unstable_Grid2";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Controller, useForm } from "react-hook-form";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ShareIcon from "@mui/icons-material/Share";
import DeleteIcon from "@mui/icons-material/Delete";
import SendAndArchiveIcon from "@mui/icons-material/SendAndArchive";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";
import { RiDeleteBin6Line, RiPencilLine } from "react-icons/ri";
import * as ApiCall from "../../../../../API/ApiCalling";
import "./../css/coupon.css";
import DisplayImage from "./../DisplaySection/DisplayImage";

import Folder from "./../DisplaySection/Folder";

import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import { makeStyles, styled } from "@mui/styles";
import "./../css/project_folder.css";
import ListItems from "./ListItems";

import { useSnapshot } from "valtio";
import { widState } from "../../../store/workdriveState";
import FileImageCard from "./../DisplaySection/DisplayFile";
import { changeName } from "./../Global/FileResponseChanger";
import ClipboardCopy from "../Modals/ClipboardCopy";
import { Box } from "@mui/system";
import { workdriveUrl } from "../../../../../../config/zohoConstant";
import { getRoleButtons } from "../../../../../../config/scope";

const useStyles = makeStyles({
  grid: {
    border: "1px solid black",
  },
  icon: {
    fontSize: "25px !important",
  },
});

const ModalText = styled("span")({
  color: "#616364",
  marginLeft: "-5PX",
});

function CommonComponent({
  file,
  handleClick,
  settingId,
  setPost,
  post,
  settingUrl,
  orgid,
  connname,
  apikey,
  datacenterurl,
  setSnackOpen,
  moveCopyData,
  pasteData,
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [shareOpen, setShareOpen] = React.useState(false);
  const [shareFullAccessOpen, setShareFullAccessOpen] = React.useState(false);
  const [collectFilesOpen, setCollectFilesOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [sharedFileOpen, setSharedOpen] = useState(false);
  const [sharedLink, setSharedLink] = useState("");
  const [name, setName] = React.useState(file.name);
  const [id, setId] = React.useState("");
  const [showRightOptions, setShowRightOption] = useState(true);
  const snap = useSnapshot(widState);
  const { handleSubmit, control, reset } = useForm();

  const onSubmitRename = async (data) => {
    snap.setLoading(true);
    setShareOpen((prev) => false);
    setShareFullAccessOpen((prev) => false);
    setCollectFilesOpen((prev) => false);
    setOpen((prev) => false);

    let snackMessage = {
      bool: true,
      type: "error",
      message: "Request failed",
    };

    try {
      const response = await ApiCall.renameFileFolder(
        { name: data?.name },
        file,
        connname,
        orgid,
        apikey,
        datacenterurl,
        settingUrl
      );

      if (response?.data) {
        let tempResponse = changeName(response, file);
        let tempArray = post.map((file) =>
          // file.id !== response.data?.id ? file : tempResponse,
          file.id !== tempResponse?.id ? file : response.data
        );
        widState?.setAddItemSettingData(
          settingId,
          tempResponse.parent_id,
          tempArray
        );
        snackMessage = {
          bool: true,
          type: "success",
          message: "Renamed successfully",
        };
        setPost(tempArray);
        
      } else {
        snackMessage = {
          bool: true,
          type: "error",
          message: response?.error,
        };
      }
      reset();
      snap.setSnackbar(snackMessage);
      snap.setLoading(false);
    } catch (error) {
      snap.setSnackbar(snackMessage);
    }
    snap.setLoading(false);
  };

  const onSubmitShareDownloadOnly = async (data) => {
    snap.setLoading(true);
    setShareOpen((prev) => false);
    setShareFullAccessOpen((prev) => false);
    setCollectFilesOpen((prev) => false);
    setOpen((prev) => false);

    let snackMessage = {
      bool: true,
      type: "error",
      message: "Request failed",
    };

    try {
      
        // password = "", expirationDate
        const bodyData = {
          password: data?.password || "",
          expirationDate: Boolean(data?.dateTime)
            ? data?.dateTime?.replace("T", " ") + ":00"
            : "",
        };

        const response = await ApiCall.shareFileFolder(
          bodyData,
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
        reset();
    } catch (error) {
      snap.setSnackbar(snackMessage);
    }
    snap.setLoading(false);
  };

  const onSubmitShareFullAccess = async (data) => {
    snap.setLoading(true);
    setShareOpen((prev) => false);
    setShareFullAccessOpen((prev) => false);
    setCollectFilesOpen((prev) => false);
    setOpen((prev) => false);

    let snackMessage = {
      bool: true,
      type: "error",
      message: "Request failed",
    };

    try {
      
        // password = "", expirationDate

        const bodyData = {
          password: data?.fullAccessPassword || "",
          expirationDate: Boolean(data?.fullAccessDateTime)
            ? data?.fullAccessDateTime?.replace("T", " ") + ":00"
            : "",
        };
        const response = await ApiCall.shareFullAccess(
          bodyData,
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
        snap.setSnackbar(snackMessage);
        reset();

    } catch (error) {
      snap.setSnackbar(snackMessage);
    }
    snap.setLoading(false);
  };

  const onSubmitCollectFiles = async (data) => {
    snap.setLoading(true);
    setShareOpen((prev) => false);
    setShareFullAccessOpen((prev) => false);
    setCollectFilesOpen((prev) => false);
    setOpen((prev) => false);

    let snackMessage = {
      bool: true,
      type: "error",
      message: "Request failed",
    };

    try {
        // password = "", expirationDate
        const bodyData = { collectionName: data?.collectionName };
        if (data?.groupedBy) {
          bodyData["groupedBy"] = data?.groupedBy;
        }
        if (Boolean(data.collectFileDateTime)) {
          bodyData["expirationDate"] = data?.collectFileDateTime?.replace(
            "T",
            " "
          );
        }
        const response = await ApiCall.collectFiles(
          bodyData,
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
        snap.setSnackbar(snackMessage);
        reset();
      
    } catch (error) {
      snap.setSnackbar(snackMessage);
    }
    snap.setLoading(false);
  };

  const onSubmit = async (data) => {
    snap.setLoading(true);
    setShareOpen((prev) => false);
    setShareFullAccessOpen((prev) => false);
    setCollectFilesOpen((prev) => false);
    setOpen((prev) => false);

    let snackMessage = {
      bool: true,
      type: "error",
      message: "Request failed",
    };

    try {
      if (Object.keys(data)?.includes("password")) {
        // password = "", expirationDate
        const bodyData = {
          password: data?.password || "",
          expirationDate: Boolean(data?.dateTime)
            ? data?.dateTime?.replace("T", " ") + ":00"
            : "",
        };

        const response = await ApiCall.shareFileFolder(
          bodyData,
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
      } else if (Object.keys(data)?.includes("fullAccessPassword")) {
        // password = "", expirationDate

        const bodyData = {
          password: data?.fullAccessPassword || "",
          expirationDate: Boolean(data?.fullAccessDateTime)
            ? data?.fullAccessDateTime?.replace("T", " ") + ":00"
            : "",
        };
        const response = await ApiCall.shareFullAccess(
          bodyData,
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
        snap.setSnackbar(snackMessage);

        // const response = await ApiCall.shareFileFolder(
        //   {password: data?.fullAccessPassword, expirationDate: data?.fullAccessDateTime?.replace("T", " ") + ":00"},
        //   file,
        //   connname,
        //   orgid,
        //   apikey,
        //   datacenterurl,
        //   settingUrl
        // );
        // if (response?.error) {
        //   snackMessage = {
        //     bool: true,
        //     type: "error",
        //     message: response?.error?.errors[0]?.title,
        //   };

        //   snap.setSnackbar(snackMessage);
        //   snap.setLoading(false);
        //   return;
        // }

        // snackMessage = {
        //   bool: true,
        //   type: "success",
        //   message: "File shared successfully",
        // };

        // setSharedLink((prev) => response?.data?.data?.attributes?.link);
        // setSharedOpen((prev) => true);
      } else if (Object.keys(data)?.includes("collectionName")) {
        // password = "", expirationDate
        const bodyData = { collectionName: data?.collectionName };
        if (data?.groupedBy) {
          bodyData["groupedBy"] = data?.groupedBy;
        }
        if (Boolean(data.collectFileDateTime)) {
          bodyData["expirationDate"] = data?.collectFileDateTime?.replace(
            "T",
            " "
          );
        }
        const response = await ApiCall.collectFiles(
          bodyData,
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
        snap.setSnackbar(snackMessage);
      } else if (data?.name) {
        const response = await ApiCall.renameFileFolder(
          { name: data?.name },
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.data) {
          let tempResponse = changeName(response, file);
          let tempArray = post.map((file) =>
            // file.id !== response.data?.id ? file : tempResponse,
            file.id !== tempResponse?.id ? file : response.data
          );
          widState?.setAddItemSettingData(
            settingId,
            tempResponse.parent_id,
            tempArray
          );
          snackMessage = {
            bool: true,
            type: "success",
            message: "Renamed successfully",
          };
          setPost(tempArray);
        } else {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error,
          };
        }

        snap.setSnackbar(snackMessage);
        snap.setLoading(false);
        // // ;
      } else {
        const response = await ApiCall.shareFileFolder(
          {},
          file,
          connname,
          orgid,
          apikey,
          datacenterurl,
          settingUrl
        );

        if (response?.error) {
          snackMessage = {
            bool: true,
            type: "error",
            message: response?.error?.errors?.[0]?.title,
          };

          snap.setSnackbar(snackMessage);
          snap.setLoading(false);
          return;
        }

        snackMessage = {
          bool: true,
          type: "success",
          message: "File shared successfully",
        };

        setSharedLink((prev) => response?.data?.data?.attributes?.link);
        setSharedOpen((prev) => true);
      }
      snap.setSnackbar(snackMessage);
    } catch (error) {
      snap.setSnackbar(snackMessage);
    }
    snap.setLoading(false);
  };


  const handleShareFileFolder = async (data) => {
    snap.setLoading(true);
    setShareOpen((prev) => false);
    setOpen((prev) => false);
    let snackMessage = {
      bool: true,
      type: "error",
      message: "Request failed",
    };

    try {
      const response = await ApiCall.shareFullAccess(
        {},
        file,
        connname,
        orgid,
        apikey,
        datacenterurl,
        settingUrl
      );

      if (response?.error) {
        snackMessage = {
          bool: true,
          type: "error",
          message: response?.error?.errors[0]?.title,
        };

        snap.setSnackbar(snackMessage);
        snap.setLoading(false);
        return;
      }

      snackMessage = {
        bool: true,
        type: "success",
        message: "File shared successfully",
      };

      setSharedLink((prev) => response?.data?.data?.attributes?.link);
      setSharedOpen((prev) => true);
      snap.setSnackbar(snackMessage);
    } catch (error) {
      snap.setSnackbar(snackMessage);
    }
    snap.setLoading(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickShareDownloadOnlyOpen = () => {
    setShareOpen(true);
  };

  const handleClickShareFullaccessOpen = () => {
    setShareFullAccessOpen(true);
  };

  const handleClickCollectFilesOpen = () => {
    setCollectFilesOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShareOpen(false);
    setSharedOpen((prev) => false);
    setShareFullAccessOpen(false);
    setCollectFilesOpen((prev) => false);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false);
  };

  const deleteData = (e, data) => {
    snap.setLoading(true);
    handleCloseDeleteDialog();
    data = file;
    let tempView = snap?.view;
    // if (tempView) {
    //   snap.setViewSettingData(settingId, false);
    // }
    ApiCall.deleteFileFolder(
      data,
      connname,
      orgid,
      apikey,
      datacenterurl,
      settingUrl
    )
      .then((response) => {
        // ;
        if (response?.data) {
          let xArray = post.filter((file) => file.id != data.id);
          // setSnackOpen(true);
          snap.setSnackbar({
            bool: true,
            type: "success",
            message: "File deleted successfully",
          });
          setPost(xArray);

          let lastIndex =
            widState?.settingData?.[settingId]?.breadCrumbs?.length - 1;
          let lastIndexId =
            widState?.settingData?.[settingId]?.breadCrumbs?.[lastIndex].id;
          widState?.setAddItemSettingData(settingId, lastIndexId, xArray);
        } else {
          snap.setSnackbar({
            bool: true,
            type: "error",
            message:
              response?.error ||
              "Couldn't delete the file. Please check your internet connection or other setting.",
          });
        }

        // if (tempView) {
        //   snap.setViewSettingData(settingId, true);
        // }
        snap.setLoading(false);
      })
      .catch((error) => {
        // alert(error);

        // if (tempView) {
        //   snap.setViewSettingData(settingId, true);
        // }
        snap.setSnackbar({
          bool: true,
          type: "error",
          message:
            "Couldn't delete the file. Please check your internet connection or other setting.",
        });
        snap.setLoading(false);
      });
  };

  const handleView = (file) => {
    if (snap?.view == "list" && file?.type !== "folder") {
      return (
        <ListItems
          setShowRightOption={setShowRightOption}
          file={file}
          settingId={settingId}
          orgid={orgid}
          connname={connname}
          apikey={apikey}
          datacenterurl={datacenterurl}
          settingUrl={settingUrl}
        />
      );
    }
    return (
      <InputDecider
        setShowRightOption={setShowRightOption}
        file={file}
        settingId={settingId}
        orgid={orgid}
        connname={connname}
        apikey={apikey}
        datacenterurl={datacenterurl}
        settingUrl={settingUrl}
        handleClick={handleClick}
        post={post}
        setSnackOpen={setSnackOpen}
        setPost={setPost}
      />
    );
  };

  const getDefaultName = (file) => {
    let modifiedName = "";
    if (file?.type != "folder") {
      modifiedName = file?.name?.split(".")?.[2]
        ? file?.name?.split(".").slice(0, -1)?.join(".")
        : file?.name?.split(".")?.[0];
    } else {
      modifiedName = file?.name;
    }
    return modifiedName;
  };

  return (
    <>
      <ContextMenuTrigger id={file?.id}>{handleView(file)}</ContextMenuTrigger>
      {showRightOptions && (
        <ContextMenu style={{ width: 350 }} id={file.id}>
          {getRoleButtons(widState?.role)?.includes("Rename") ? (
            <MenuItem data={file} onClick={handleClickOpen}>
              <RiPencilLine className="RiPencilLine" />
              <ModalText style={{ fontSize: 17, py: 0.2 }}> Rename </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}
          {getRoleButtons(widState?.role)?.includes("Copy") ? (
            <MenuItem
              data={{
                type: "copy",
                file: file,
                parentFiles: post,
              }}
              onClick={moveCopyData}
            >
              <ContentCopyIcon className="RiPencilLine" />
              <ModalText style={{ fontSize: 17, py: 0.2 }}> Copy </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}

          {getRoleButtons(widState?.role)?.includes("Paste") &&
          snap?.pasteOpen ? (
            <MenuItem
              data={{
                pasteFile: file,
                pastePost:
                  snap?.settingData?.[settingId]?.previousData?.[file?.id],
              }}
              onClick={pasteData}
            >
              <ContentPasteIcon className="RiPencilLine" />
              <ModalText style={{ fontSize: 17, py: 0.2 }}> Paste </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}

          {getRoleButtons(widState?.role)?.includes("Cut") ? (
            <MenuItem
              data={{
                type: "move",
                file: file,
                parentFiles: post,
              }}
              onClick={moveCopyData}
            >
              <DriveFileMoveIcon className="RiPencilLine" />
              <ModalText style={{ fontSize: 17, py: 0.2 }}> Cut </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}

          {file?.type != "folder" ? (
            <>
              <MenuItem
                onClick={async () => {
                  try {
                    let response = await ApiCall.getImageResponse(
                      file,
                      connname,
                      orgid,
                      apikey,
                      datacenterurl,
                      widState.dataCenter,
                      settingUrl
                    );
                    let url = "";

                    if (
                      file?.type == "spreadsheet" ||
                      file?.type == "zohosheet"
                    ) {
                      url = window.URL.createObjectURL(
                        new Blob([response.data], {
                          type: "text/csv;charset=utf-8",
                        })
                      );
                    } else {
                      url = window.URL.createObjectURL(
                        new Blob([response.data])
                      );
                    }

                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", file.name); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                  } catch (error) {
                  }
                }}
              >
                <DownloadOutlinedIcon className="RiPencilLine" />
                <ModalText style={{ fontSize: 17, py: 0.2 }}>
                  {" "}
                  Download{" "}
                </ModalText>
              </MenuItem>
              <MenuItem
                data={file}
                onClick={() => {
                  window.open(
                    `${workdriveUrl?.[widState.dataCenter]}/file/${file?.id}`,
                    "_blank",
                    "noreferrer"
                  );
                }}
              >
                <OpenInNewIcon className="RiPencilLine" />
                <ModalText style={{ fontSize: 17, py: 0.2 }}>
                  {" "}
                  Open in Workdrive
                </ModalText>
              </MenuItem>
            </>
          ) : (
            <>
              {getRoleButtons(widState?.role)?.includes("Collect Files") ? (
                <MenuItem
                  data={file}
                  onClick={() => {
                    handleClickCollectFilesOpen();
                  }}
                >
                  <OpenInNewIcon className="RiPencilLine" />
                  <ModalText style={{ fontSize: 17, py: 0.2 }}>
                    {" "}
                    Collect Files
                  </ModalText>
                </MenuItem>
              ) : (
                <></>
              )}
              <MenuItem
                data={file}
                onClick={() => {
                  window.open(
                    `${workdriveUrl?.[widState?.dataCenter]}/folder/` +
                      file?.id +
                      "?layout=list",
                    "_blank",
                    "noreferrer"
                  );
                }}
              >
                <OpenInNewIcon className="RiPencilLine" />
                <ModalText style={{ fontSize: 17, py: 0.2 }}>
                  {" "}
                  Open in Workdrive
                </ModalText>
              </MenuItem>
            </>
          )}

          {getRoleButtons(widState?.role)?.includes(
            "Ext. Share Link(Download Only)"
          ) ? (
            <MenuItem
              onClick={handleClickShareDownloadOnlyOpen}
            >
              <SendAndArchiveIcon className="RiPencilLine" />
              <ModalText style={{ fontSize: 17, py: 0.2 }}>
                {" "}
                Ext. Share Link(Download Only)
              </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}

          {getRoleButtons(widState?.role)?.includes(
            "Ext. Share Link(Full Access)"
          ) ? (
            <MenuItem
              onClick={() => {
                // setShareOpen(true);
                handleClickShareFullaccessOpen();
                // handleShareFileFolder();
              }}
            >
              <ShareIcon className="RiPencilLine" />
              <ModalText style={{ fontSize: 17, py: 0.2 }}>
                {" "}
                Ext. Share Link(Full Access)
              </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}

          {getRoleButtons(widState?.role)?.includes("Delete") ? (
            <MenuItem
              data={file}
              onClick={() => {
                setDeleteOpen(true);
              }}
            >
              <RiDeleteBin6Line className="delete RiPencilLine" />

              <ModalText style={{ fontSize: 17, py: 0.2 }}> Delete </ModalText>
            </MenuItem>
          ) : (
            <></>
          )}
        </ContextMenu>
      )}

      <Dialog
        open={deleteOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "400px", // Set your width here
              padding: "10px",
            },
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "23px", fontWeight: 500 }}
        >
          {"Delete Item"}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              pb: 2,
            }}
          >
            Do you really want to delete this item?
          </Box>
          <div style={{ display: "flex", justifyContent: "end", gap: 3 }}>
            <Button
              sx={{ marginTop: "10px", mr: 2, color: "#1976D2" }}
              onClick={handleCloseDeleteDialog}
            >
              Cancel
            </Button>
            <Button
              sx={{ marginTop: "10px" }}
              variant="contained"
              color="error"
              onClick={deleteData}
            >
              Delete
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "400px", // Set your width here
              padding: "10px",
            },
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "23px", fontWeight: 500 }}
        >
          {"Rename"}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmitRename)}>
            <Controller
              name="name"
              control={control}
              defaultValue={getDefaultName(file)}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  id="standard-basic"
                  variant="standard"
                  {...field}
                  fullWidth
                />
              )}
            />

            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                sx={{ marginTop: "10px", mr: 2, color: "#1976D2" }}
                onClick={handleClose}
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                sx={{ marginTop: "10px", bgcolor: "#1976D2" }}
                type="submit"
                variant="contained"
              >
                Rename
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={shareOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="share-popup"
        // sx={{
        //   "& .MuiDialog-container": {
        //     "& .MuiPaper-root": {
        //       width: "100%",
        //       maxWidth: "400px", // Set your width here
        //       padding: "10px",
        //     },
        //   },
        // }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "23px", fontWeight: 500 }}
        >
          Share Item (Download Only)
        </DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit(onSubmitShareDownloadOnly)}>
            <Grid2 container spacing={2} sx={{ my: ".5rem" }}>
              <Grid2 xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography >Set password</Typography>
              </Grid2>

              <Grid2 xs={6}>
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id="outlined-number"
                      placeholder="Password"
                      variant="outlined"
                      size="small"
                      {...field}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                          >
                            {true ? <VisibilityOff /> : <Visibility />}
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid2>

              {/* <Grid2
                xs={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Switch
                  // checked={checked}
                  // onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid2> */}
            </Grid2>

            <Divider sx={{ mb: ".5rem" }} />

            <Grid2 container spacing={2} sx={{ my: ".5rem" }}>
              <Grid2 xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography >
                  Set expiration after
                </Typography>
              </Grid2>

              <Grid2 xs={6}>
                <Controller
                  name="dateTime"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    return (
                      <TextField
                        id="outlined-number"
                        placeholder="Password"
                        variant="outlined"
                        size="small"
                        {...field}
                        type="datetime-local"
                        fullWidth
                      />
                    );
                  }}
                />

                {/* <Controller
                  name="duration"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id="outlined-number"
                      label="Access Duration in days"
                      type="number"
                      variant="standard"
                      {...field}
                      fullWidth
                    />
                  )}
                /> */}
              </Grid2>

              {/* <Grid2
                xs={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Switch
                  // checked={checked}
                  // onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid2> */}
            </Grid2>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                sx={{ marginTop: "10px", mr: 2, color: "#1976D2" }}
                variant="outlined"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                sx={{ marginTop: "10px", bgcolor: "#1976D2" }}
                type="submit"
                variant="contained"
              >
                Share
              </Button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={shareFullAccessOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="share-popup"
        // sx={{
        //   "& .MuiDialog-container": {
        //     "& .MuiPaper-root": {
        //       width: "100%",
        //       maxWidth: "400px", // Set your width here
        //       padding: "10px",
        //     },
        //   },
        // }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "23px", fontWeight: 500 }}
        >
          Share Item (Full Access)
        </DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={handleSubmit(onSubmitShareFullAccess)}>
            <Grid2 container spacing={2} sx={{ my: ".5rem" }}>
              <Grid2 xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography >Set password</Typography>
              </Grid2>

              <Grid2 xs={6}>
                <Controller
                  name="fullAccessPassword"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id="outlined-number"
                      placeholder="Password"
                      variant="outlined"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                          >
                            {true ? <VisibilityOff /> : <Visibility />}
                          </InputAdornment>
                        ),
                      }}
                      {...field}
                      fullWidth
                    />
                  )}
                />
              </Grid2>

              {/* <Grid2
                xs={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Switch
                  // checked={checked}
                  // onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid2> */}
            </Grid2>

            <Divider sx={{ mb: ".5rem" }} />

            <Grid2 container spacing={2} sx={{ my: ".5rem" }}>
              <Grid2 xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography >
                  Set expiration after
                </Typography>
              </Grid2>

              <Grid2 xs={6}>
                <Controller
                  name="fullAccessDateTime"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    return (
                      <TextField
                        id="datetime-local"
                        size="small"
                        {...field}
                        type="datetime-local"
                        fullWidth
                      />
                    );
                  }}
                />
              </Grid2>

              {/* <Grid2
                xs={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Switch
                  // checked={checked}
                  // onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid2> */}
            </Grid2>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                sx={{ marginTop: "10px", mr: 2, color: "#1976D2" }}
                variant="outlined"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                sx={{ marginTop: "10px", bgcolor: "#1976D2" }}
                type="submit"
                variant="contained"
              >
                Share
              </Button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={collectFilesOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // sx={{
        //   "& .MuiDialog-container": {
        //     "& .MuiPaper-root": {
        //       width: "100%",
        //       // maxWidth: "400px", // Set your width here
        //       padding: "10px",
        //       wordWrap: "break-word",
        //     },
        //   },
        // }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "23px", fontWeight: 500 }}
        >
          Collect Files
        </DialogTitle>

        <DialogContent>
          <Box component="form" onSubmit={handleSubmit(onSubmitCollectFiles)}>
            <Box sx={{ my: ".5rem" }}>
              <Controller
                name="collectionName"
                control={control}
                render={({ field }) => (
                  <TextField
                    id="outlined-number"
                    placeholder="Enter Collection Name"
                    variant="outlined"
                    size="small"
                    {...field}
                    required
                    fullWidth
                  />
                )}
              />
            </Box>

            <Grid2 container spacing={2} sx={{ my: ".5rem" }}>
              <Grid2 xs={3.5} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>Set expiration</Typography>
              </Grid2>

              <Grid2 xs={6}>
                <Controller
                  name="collectFileDateTime"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    return (
                      <TextField
                        id="datetime-local"
                        size="small"
                        {...field}
                        type="datetime-local"
                        fullWidth
                      />
                    );
                    return (
                      <input
                        {...field}
                        type="datetime-local"
                        className="p-2 border rounded-lg"
                      />
                    );
                  }}
                />
              </Grid2>

              {/* <Grid2
                xs={2.5}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Switch
                  // checked={checked}
                  // onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid2> */}
            </Grid2>

            <Divider sx={{ mb: ".5rem" }} />

            <Box sx={{ mb: ".5rem" }}>
              {/* <RadioButton */}

              <Controller
                name="groupedBy"
                control={control}
                defaultValue="email"
                render={({ field }) => (
                  <FormControl {...field}>
                    <FormLabel id="demo-radio-buttons-group-label">
                      Uploaded file group by
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="email"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        value={null}
                        control={<Radio />}
                        label="None"
                      />
                      <FormControlLabel
                        value="email"
                        control={<Radio />}
                        label="Email"
                      />
                      <FormControlLabel
                        value="name"
                        control={<Radio />}
                        label="Name"
                      />
                    </RadioGroup>
                  </FormControl>
                )}
              />

              {/* <Controller
                  name="duration"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id="outlined-number"
                      label="Access Duration in days"
                      type="number"
                      variant="standard"
                      {...field}
                      fullWidth
                    />
                  )}
                /> */}
            </Box>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                sx={{ marginTop: "10px", mr: 2, color: "#1976D2" }}
                variant="outlined"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                sx={{ marginTop: "10px", bgcolor: "#1976D2" }}
                type="submit"
                variant="contained"
              >
                Submit
              </Button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={sharedFileOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              // maxWidth: "400px", // Set your width here
              padding: "10px",
              wordWrap: "break-word",
            },
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontSize: "23px", fontWeight: 500 }}
        >
          {"Share Item"}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            sx={{ padding: "15px", backgroundColor: "#001E3C", color: "#fff" }}
          >
            <Grid xs={11}>{sharedLink}</Grid>
            <Grid xs={1} sx={{ paddingLeft: "5px" }}>
              <ClipboardCopy copyText={sharedLink} />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default CommonComponent;

const InputDecider = ({
  setShowRightOption,
  file,
  settingId,
  handleClick,
  post,
  orgid,
  connname,
  apikey,
  datacenterurl,
  settingUrl,
  setSnackOpen,
  setPost,
}) => {
  const classes = useStyles();
  const snap = useSnapshot(widState);

  function handleDragEnter(e) {
    // setTimeout(() => {
    //   ;
    //   setShowRightOption((prev) => false);
    // }, 500);

    e.preventDefault();
    e.stopPropagation();
    e.target.style.background = "#EDF6FF";
  }

  function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    e.target.style.background = "";
  }

  const handleStart = (event, file) => {
    setShowRightOption((prev) => false);

    event.dataTransfer.setData(
      "moveData",
      JSON.stringify({
        fileName: file?.file?.name,
        dropFile: event?.target?.id,
        fileType: file?.file?.type,
        dropFileParentId: file?.file?.parent_id,
      })
    );
    setTimeout(() => {
      setShowRightOption((prev) => true);
    }, 1000);
  };

  const handleDrop = (event, file) => {
    event.preventDefault();
    event.target.style.background = "";
    var moveData = JSON.parse(event.dataTransfer.getData("moveData"));
    if (!moveData?.dropFile) {
      return;
    }

    if (moveData?.dropFile === file?.id) {
      return;
    }

    snap.setLoading(true);

    handleDragLeave(event);
    let tempView = snap.settingData?.[settingId]?.view;
    // if (tempView) {
    //   snap.setViewSettingData(settingId, false);
    // }

    if (moveData?.dropFile && moveData?.dropFile !== file?.id) {
      ApiCall.moveFile(
        file,
        {
          id: moveData?.dropFile,
          parent_id: moveData?.dropFileParentId,
        },
        connname,
        orgid,
        apikey,
        datacenterurl,
        settingUrl
      )
        .then((response) => {
          if (response?.data) {
            let xArray = post.filter((file) => file.id != moveData?.dropFile);
            setPost(xArray);
            // if (tempView) {
            //   snap.setViewSettingData(settingId, true);
            // }
            let lastIndex =
              widState?.settingData?.[settingId]?.breadCrumbs?.length - 1;
            let lastIndexId =
              widState?.settingData?.[settingId]?.breadCrumbs?.[lastIndex].id;
            widState?.setAddItemSettingData(
              settingId,
              moveData?.dropFileParentId,
              xArray
            );
            // widState?.setApiSettingData(settingId, moveData?.dropFileParentId, xArray);

            if (
              widState?.settingData?.[settingId]?.previousData?.hasOwnProperty(
                `${file?.id}`
              )
            ) {
              let tempArray = JSON.parse(
                JSON.stringify(
                  widState?.settingData?.[settingId]?.previousData?.[file?.id]
                )
              );
              tempArray = tempArray.concat([response?.data]);
              // // ;
              widState?.setAddItemSettingData(settingId, file?.id, tempArray);
              // snap?.setApiSettingData(settingId, file?.id, tempArray);
            }

            snap.setSnackbar({
              bool: true,
              type: "success",
              message: "Item moved successfully",
            });
          } else {
            // if (tempView) {
            //   snap.setViewSettingData(settingId, true);
            // }
            snap.setSnackbar({
              bool: true,
              type: "error",
              message: "Item moved failed",
            });
          }

          snap.setLoading(false);
          // event.dataTransfer.setData("moveData", null);
          // // ;
        })
        .catch((error) => {
          snap.setLoading(false);
          snap.setSnackbar({
            bool: true,
            type: "error",
            message: "There is an error while moving. Check Internet",
          });
          // // ;
        });
    }
  };

  let inputProps = {
    file,
    handleClick,
  };

  switch (file?.type) {
    case "folder":
      return (
        <Grid
          // sx={{ paddingTop: "2px !important" }}
          onClick={() => {
            handleClick(
              file,
              widState?.settingData?.[settingId]?.previousData?.[file?.id]
            );
          }}
          {...inputProps}
          id={file.id}
          draggable="true"
          onDragStart={(e) => handleStart(e, { file: file })}
          onDrop={(e) => {
            handleDrop(e, file);
          }}
          onDragEnter={(e) => handleDragEnter(e)}
          onDragLeave={(e) => handleDragLeave(e)}
        >
          <Folder
            icon={<FolderOutlinedIcon className={classes.icon} />}
            file={file}
            orgid={orgid}
            connname={connname}
            apikey={apikey}
            datacenterurl={datacenterurl}
            settingUrl={settingUrl}
          />
        </Grid>
      );
      break;
    case "image":
      // // ;
      return (
        <Grid
          draggable="true"
          id={file.id}
          onDragStart={(e) => handleStart(e, { file: file })}
          Dragend
          sx={{
            "&:hover": {
              boxShadow: "-0px 0px 11px 1px rgba(0,0,0,0.20)",
            },
          }}
        >
          <DisplayImage
            file={file}
            settingId={settingId}
            orgid={orgid}
            connname={connname}
            apikey={apikey}
            datacenterurl={datacenterurl}
            settingUrl={settingUrl}
          />
        </Grid>
      );
      break;
    case "pdf":
      return (
        <Grid
          draggable="true"
          id={file.id}
          onDragStart={(e) => handleStart(e, { file: file })}
          sx={{
            "&:hover": {
              boxShadow: " -0px 0px 11px 1px rgba(0,0,0,0.20)",
            },
          }}
        >
          <ActionAreaCard
            file={file}
            settingId={settingId}
            orgid={orgid}
            connname={connname}
            apikey={apikey}
            datacenterurl={datacenterurl}
            settingUrl={settingUrl}
          />
        </Grid>
      );
      break;
    case "video":
      return (
        <Grid
          draggable="true"
          id={file.id}
          onDragStart={(e) => handleStart(e, { file: file })}
          sx={{
            "&:hover": {
              boxShadow: " -0px 0px 11px 1px rgba(0,0,0,0.20)",
            },
          }}
        >
          <ActionAreaCard
            file={file}
            settingId={settingId}
            orgid={orgid}
            connname={connname}
            apikey={apikey}
            datacenterurl={datacenterurl}
            settingUrl={settingUrl}
          />
        </Grid>
      );
      break;
    default:
      return (
        <Grid
          draggable="true"
          id={file.id}
          onDragStart={(e) => handleStart(e, { file: file })}
          sx={{
            "&:hover": {
              boxShadow: " -0px 0px 11px 1px rgba(0,0,0,0.20)",
            },
          }}
        >
          <FileImageCard
            file={file}
            settingId={settingId}
            orgid={orgid}
            connname={connname}
            apikey={apikey}
            datacenterurl={datacenterurl}
            settingUrl={settingUrl}
          />
        </Grid>
      );
      break;
  }
  return <></>;
};
